export default "__VITE_ASSET__88OAUtQq__"